import useMoney from '@resources/js/app/composables/useMoney.js';
import useMortgage from '@resources/js/app/composables/useMortgage.js';

const { formatMoney, convertCurrency } = useMoney();
const { getMonthlyInterest, getMonthlyInstallments, getLoanTermMonths, getLoanX, getAdvancePayment } = useMortgage();

export default ({ interestRate, loanTenure, loanAmount, currencyExchangeRate, installmentPlaceHolder }) => ({
    get monthlyInstallment() {
        let creditAmount = loanAmount - getAdvancePayment(15, loanAmount);

        let monthlyInterest = getMonthlyInterest(interestRate);
        let loanTermMonths = getLoanTermMonths(loanTenure);
        let loanX = getLoanX(monthlyInterest, loanTermMonths);

        return getMonthlyInstallments(creditAmount, loanX, monthlyInterest);
    },

    get simulatedMonthlyInstallment() {
        let monthlyInstallment = this.monthlyInstallment;

        let convertedAmount = convertCurrency(monthlyInstallment, currencyExchangeRate);

        let installment = formatMoney(convertedAmount, '.', 'RON');

        return installmentPlaceHolder.replace(':installment', installment);
    },
});
